import { render, staticRenderFns } from "./ResultadoFiltro.vue?vue&type=template&id=0a853bcb"
import script from "./ResultadoFiltro.vue?vue&type=script&lang=js"
export * from "./ResultadoFiltro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports